<template>
  <div>
    <div class="employe" v-if="path=='employe'">
      <el-backtop target=".employe"></el-backtop>
      <header-top :headerText="headerText" haveTab></header-top>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部人员" name="all-employe"></el-tab-pane>
        <!-- <el-tab-pane label="待入职审核" name="waiting-employe"></el-tab-pane>
        <el-tab-pane label="待转正审核" name="waiting-regular"></el-tab-pane>
        <el-tab-pane label="岗位异动审核" name="change-audit"></el-tab-pane>
        <el-tab-pane label="待离职审核" name="waiting-quit"></el-tab-pane> -->
        <el-tab-pane label="在职人员" name="regular-employe"></el-tab-pane>
        <el-tab-pane label="在职不在岗" name="regular-isLockout-employe"></el-tab-pane>
        <el-tab-pane label="已离职" name="quit-employe"></el-tab-pane>
      </el-tabs>
      <!-- isLockout == true -->
      <div class="tab-box">
        <employe-all :peopleHeight="mainHeight" :activeName="activeName"></employe-all>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { debounce } from "@/utils/debounce";
import employeAll from "./employe-all";
export default {
  data() {
    return {
      listTableHeight: {
        minHeight: document.body.clientHeight - 125 + "px"
      },
      mainHeight: {
        minHeight: document.body.clientHeight - 110 + "px"
      },
      activeName: "all-employe",
      headerText: "分销人员"
    };
  },
  components: {
    employeAll,
    headerTop,
  },
  created() {
    window.onresize = debounce(() => {
      this.listTableHeight.minHeight = document.body.clientHeight - 225 + "px";
      this.mainHeight.minHeight = document.body.clientHeight - 110 + "px";
    }, 100);
  },
  computed: {
    path() {
      return this.$route.name;
    }
  },
  methods: {
    handleClick(tab, event) {
      //console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.employe {
  width: 100%;
  height: 100%;

  // ::v-deep .el-tabs__content {
  //   background-color: #f2f2f2;
  // }
}

.tab-box,
main {
  padding: 20px;
}
</style>
